import Components from "slotworks/components/components";
import Contract from "slotworks/utils/contracts/contract";

export function HideAllLinesCommand(): Contract<void> {

    Components.lines.hideAllLines();

    return new Contract<void>((resolve) => { resolve(null); });
}
